import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import UserDetail from '../components/layouts/admin/employee-detail';
import EmployeeListView from '../components/layouts/admin/employee-list-view';
import EmployeeResume from '../components/uicontainers/resume/employee-resume';
import Resume from '../components/uicontainers/resume/index';
import AdminProfile from '../pages/admin';
import Home from '../pages/home';
import SignInPage from '../pages/signin';
import SignUpPage from '../pages/signup';
import UserProfile from '../pages/user';
// import axiosInstance from '../axios_instance';
import axiosInstance from '../axios_instance';
import ProfileListView from '../components/layouts/admin/profiles-list-view';
import SkillListView from '../components/layouts/admin/skills';
import CertificationReportView from '../components/layouts/admin/certification-report';
import { BaseUrlAuth } from '../utils';
import ForgetPassword from '../pages/forget-password';
import ResetPassword from '../pages/reset-password';
import VerifyEmail from '../pages/verify-email';
import VerifyToken from '../pages/verify-email-token';

const BaseRouter = () => {
  const [isAdmin, setIsAdmin] = useState<string>();
  console.log(isAdmin);
  const navigate = useNavigate();
  useEffect(() => {
    const jwtToken = localStorage.getItem('jwt_token');
    if (isTokenExpired()) {
      localStorage.removeItem('jwt_token');
      swal({
        title: 'Session expired',
        text: 'Your session has expired, Please signin.',
        icon: 'warning',
      }).then((willRefresh) => {
        navigate('/signin');
        return;
      });
    } else if (jwtToken) {
      axiosInstance
        .get(BaseUrlAuth + '/api/v1/users/me', {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        })
        .then((response) => {
          setIsAdmin(response.data.is_admin);
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .catch((error) => {
          // history('/signin');
        });
    }
  }, []);

  const isTokenExpired = () => {
    const jwtToken = localStorage.getItem('jwt_token');
    if (jwtToken) {
      const decoded: any = jwtDecode(jwtToken);
      return Date.now() >= decoded.exp * 1000;
    } else {
      return false;
    }
  };

  return (
    <div>
      <Routes>
        <Route path="signup" element={<SignUpPage />} />
        <Route path="signin" element={<SignInPage />} />
        <Route path="/" element={<Home />} />
        {/* <Route path="/resume" element={<Resume />} /> */}
        {/* <Route path='/LeftPanel' element={<LeftPanel/>}/>
    <Route path='/RightPanel' element={<RightPanel/>}/> */}
        <Route path="user" element={<UserProfile />} />
        <Route
          path="employee-resume/:employeeId"
          element={<EmployeeResume />}
        />
        {isAdmin !== undefined && isAdmin === '1' ? (
          <>
            <Route path="admin" element={<AdminProfile />}>
              <Route path="" element={<EmployeeListView />} />
              <Route path="employee" element={<ProfileListView />} />
              <Route path="employee/:employeeId" element={<UserDetail />} />
              <Route path="resume/:employeeId" element={<Resume />} />
              <Route path="skills" element={<SkillListView />} />
              <Route path="reports" element={<CertificationReportView />} />
            </Route>
          </>
        ) : (
          <></>
        )}
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="verify-token" element={<VerifyToken />} />
        <Route path="forget-password" element={<ForgetPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
      </Routes>
    </div>
  );
};

export default BaseRouter;
